import { ApiService } from './api/api'

export default class DocumentTypeService {
	private apiService

	constructor() {
		this.apiService = new ApiService()
	}

	/**
	 * Get all document types
	 * @returns Promise
	 */
	getAll(): Promise<any> {
		return this.apiService.get(`/documents/types?category=5`)
	}
}
